export default class ChartConstants {
    public static readonly PLOT_BACKGROUND = '#FFFFFF';
    public static readonly CROSS_HAIR_COLOR = 'rgba(0,0,15,0.06)';
    public static readonly FONT_FAMILY = 'var(--bs-font-family)';
}
